<template>
  <v-app>
    <v-app-bar app clipped-left color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <router-link :to="{ name: 'dashboard' }" class="plain">
          stracker
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            :to="{ name: 'item-edit', params: { itemId: 'add' } }"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create Item</span>
      </v-tooltip>
    </v-app-bar>

    <navigation-drawer v-model="drawer" />

    <v-content>
      <router-view />

      <!-- <v-btn
        color="accent"
        dark
        fab
        fixed
        top
        right
        :to="{ name: 'item-edit', params: { itemId: 'add' } }"
        style="z-index: 5;"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-content>
    <v-footer color="primary" app class="justify-space-between">
      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
      <span class="white--text">v{{ appVersion }}</span>
    </v-footer>

    <j-snackbars />
  </v-app>
</template>

<script>
// import { mapGetters } from 'vuex'
import NavigationDrawer from "@/ui/layouts/fragments/NavigationDrawer";
import JSnackbars from "@/ui/controls/JSnackbars";

import { version as appVersion } from "@/../package.json";

export default {
  components: {
    NavigationDrawer,
    JSnackbars,
  },
  props: {
    // source: String,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    // ...mapGetters(['snackbars']),
    appVersion() {
      return appVersion;
    },
  },
};
</script>
